import { ModalWindow } from "./modalWindow.js";
import { LabeledTextInput } from "../labeledTextInput.js";
import { createRandomId } from "../util.js";

export class ModalLogin extends ModalWindow {

   constructor(app, refreshDatabase=true) {

      super();

      this.app = app;

      this.panel.classList.add('dark-transparent');

      this.elMain = HTMLElement.createFromHTML(`
         <div class="modal-login">

            <div class="container">
               <div class="description">Anmeldung</div>
               <form action="#" method="post">
                  <div class="txt-input"><input type="text" id="login-user-short" class="labeled-txt-input txt-settings" key="userShort" label="Kürzel" autocomplete="username"/></div>
                  <div class="txt-input"><input type="password" id="login-user-pwd" name="current-password" class="labeled-txt-input txt-settings" key="userPwd" label="Passwort" autocomplete="current-password"/></div>
               </form>

               <button class="btn-ok button-circle"><i class="icon-check"></i></button>
               <div id="password-forgotten">Passwort vergessen?<br>Oben den Benutzernamen eintragen<br>und dann hier klicken.</div>
               <div class="note">Benutzername bei Schülerinnen und Schülern:<br>4 Buchstaben des Nachnamens, 4 Buchstaben des Vornamens, erste Zahl des Geburtsdatums.<br>z.B. MUELGERD05</div>
            </div>

         </div>
      `);

      this.panel.append(this.elMain);

      const dm = this.app.dm;

      this.elMain.querySelector('.btn-ok').addEventListener('click', () => {

         if (!localStorage.getItem('clientId')) {
            console.log('clientid');
            localStorage.setItem('clientId', createRandomId(40));
         }

         dm.requestUserData(this.txtLoginShort.getValue(), this.txtLoginPwd.getValue())
         .then(() => {
            if (refreshDatabase) {
               localStorage.setItem('refreshDatabaseOnInit', true);
            }
            window.location.reload(true);
         })
         .catch(error => {
            toast.alert(error, { duration: 8000 });
            logger.error(error);
         });

      })

      this.txtLoginShort = new LabeledTextInput('#login-user-short', { labelText: 'Benutzername'});
      this.txtLoginPwd   = new LabeledTextInput('#login-user-pwd', { labelText: 'Passwort'});
      this.txtLoginShort.setValue('');

      document.querySelector('#password-forgotten').addEventListener('click', () => this.requestNewPassword());

      this.elMain.querySelectorAll('input').forEach(input => input.addEventListener("keypress", (event) => {
         if (event.key === "Enter") {
           event.preventDefault();
           this.elMain.querySelector('.btn-ok').click();
         }
       }));


      setTimeout(() => this.show(), 1);

   }

   async requestNewPassword() {

      const short = this.txtLoginShort.getValue();

      if (short === '') {
         toast.alert("Bitte den Benutzernamen eingeben.", { duration: 8000 });
         return;
      }

      try {
         let email = await this.app.dm.requestNewPassword(short);
         toast.message("Eine Email zum Zurücksetzen des Passworts wurde an die von Ihnen hinterlegte Emailadresse (" + email + ") gesendet.");
      }
      catch(e) {
         logger.error(e);
         toast.alert(e, { duration: 8000 });
      }

   }
   
}
